import { Controller } from '@hotwired/stimulus';
import { LiveController } from '@symfony/ux-live-component';
import { Component } from '@symfony/ux-live-component';
import { getComponent } from '@symfony/ux-live-component';

export default class extends Controller<HTMLElement> implements LiveController  {
    declare component: Component;

    async initialize() {
        this.component = await getComponent(this.element);

        /**
         * Gère correctement les erreurs levés lors de l'appel AJAX d'un re-render :
         *  - en cas d'erreur d'authent : rechargement de la page pour afficher la page de login
         *  - sinon affichage de la page d'erreur
         */
        this.component.on('response:error', async (backendResponse, controls) => {
            const status = backendResponse.response.status;

            if (status === 401 || status === 403) {
                // Recharger la page
                window.location.reload();
                return;
            }

            if (controls) {
                controls.displayError = false;
            }

            // Récupérer le HTML de la réponse
            const html = await backendResponse.getBody();
            
            // Remplacer tout le contenu de la page
            document.documentElement.innerHTML = html;
        });
    }
}